import StockPage from "./ui";

export default StockPage;
